import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectiveModule } from 'src/app/extensions/directives/directive.module';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { SpecialOfferAdminRoutingModule } from './special-offers-routing.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { EditorModule } from '@progress/kendo-angular-editor';
import { CampaignDetailsComponent } from './add-special-offer/campaign-details/campaign-details.component';
import { FinancingDetailsComponent } from './add-special-offer/financing-details/financing-details.component';
import { CampaignDescriptionComponent } from './add-special-offer/campaign-description/campaign-description.component';
import { ClientSegmentationComponent } from './add-special-offer/client-segmentation/client-segmentation.component';
import { CampaignPublishedComponent } from './add-special-offer/campaign-published/campaign-published.component';
import { SpecialOfferModalComponent } from './special-offer-modals/special-offer-modal/special-offer-modal.component';
import { PreviewInformationComponent } from './special-offer-detail/preview-information/preview-information.component';
import { PreviewComponent } from './special-offer-detail/preview/preview.component';
import { PreviewSelectorComponent } from './special-offer-detail/preview-selector/preview-selector.component';
import { IconsModule } from '@progress/kendo-angular-icons';
import { SpecialOfferInsightComponent } from './special-offer-detail/special-offer-insight/special-offer-insight.component';
import { SpecialOfferListComponent } from './special-offer-list/special-offer-list.component';
import { SpecialOfferCardViewComponent } from './special-offer-list/special-offer-card-view/special-offer-card-view.component';
import { SpecialOfferListViewComponent } from './special-offer-list/special-offer-list-view/special-offer-list-view.component';
import { SpecialOfferFilterModalComponent } from './special-offer-modals/special-offer-filter-modal/special-offer-filter-modal.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SpecialOfferEditDatesModalComponent } from './special-offer-modals/special-offer-edit-dates-modal/special-offer-edit-dates-modal.component';
import { SpecialOfferEditFilesModalComponent } from './special-offer-modals/special-offer-edit-files-modal/special-offer-edit-files-modal.component';
import { SpecialOfferEditSegmentationModalComponent } from './special-offer-modals/special-offer-edit-segmentations-modal/special-offer-edit-segmentation-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SpecialOfferAdminRoutingModule,
    InputsModule,
    DropDownsModule,
    FormsModule,
    PipeModule,
    ReactiveFormsModule,
    NgbModule,
    TranslateModule.forChild(),
    DirectiveModule,
    DateInputsModule,
    ComponentsModule,
    EditorModule,
    IconsModule,
    NgApexchartsModule,
  ],
  declarations: [
    CampaignDetailsComponent,
    FinancingDetailsComponent,
    CampaignDescriptionComponent,
    ClientSegmentationComponent,
    CampaignPublishedComponent,
    SpecialOfferModalComponent,
    SpecialOfferFilterModalComponent,
    PreviewComponent,
    PreviewInformationComponent,
    PreviewSelectorComponent,
    SpecialOfferInsightComponent,
    SpecialOfferListComponent,
    SpecialOfferCardViewComponent,
    SpecialOfferListViewComponent,
    SpecialOfferEditDatesModalComponent,
    SpecialOfferEditFilesModalComponent,
    SpecialOfferEditSegmentationModalComponent,
  ],
  exports: [],
})
export class SpecialOffersAdminModule {}
